import { Component } from '@angular/core';
import { ResourceListComponent } from '../../shared/resource-list/resource-list.component';

@Component({
  selector: 'app-organizations',
  standalone: true,
  imports: [ResourceListComponent],
  template: `<app-resource-list title="Organizations" apiPath="organizations" />`
})
export class OrganizationsComponent {}
